import { render, staticRenderFns } from "./EmailListMultiValue.vue?vue&type=template&id=39201f96"
import script from "./EmailListMultiValue.vue?vue&type=script&lang=ts"
export * from "./EmailListMultiValue.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports